module.exports = "/fonts/NunitoSans-Italic.70e804dc5b5adfc1c9c1da5f1f80dcf4.ttf";